var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGames(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "games_black_24dp") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.670000017
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home-without-login",
    transform: "translate(-25.000000, -292.000000)",
    fillRule: "nonzero",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(25.000000, 292.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "games_black_24dp"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.83333333,2.33333333 L9.83333333,4.55833333 L9,5.39166667 L8.16666667,4.55833333 L8.16666667,2.33333333 L9.83333333,2.33333333 L9.83333333,2.33333333 Z M15.6666667,8.16666667 L15.6666667,9.83333333 L13.4416667,9.83333333 L12.6083333,9 L13.4416667,8.16666667 L15.6666667,8.16666667 L15.6666667,8.16666667 Z M4.55833333,8.16666667 L5.39166667,9 L4.55833333,9.83333333 L2.33333333,9.83333333 L2.33333333,8.16666667 L4.55833333,8.16666667 L4.55833333,8.16666667 Z M9,12.6083333 L9.83333333,13.4416667 L9.83333333,15.6666667 L8.16666667,15.6666667 L8.16666667,13.4416667 L9,12.6083333 L9,12.6083333 Z M11.5,0.666666667 L6.5,0.666666667 L6.5,5.25 L9,7.75 L11.5,5.25 L11.5,0.666666667 Z M17.3333333,6.5 L12.75,6.5 L10.25,9 L12.75,11.5 L17.3333333,11.5 L17.3333333,6.5 Z M5.25,6.5 L0.666666667,6.5 L0.666666667,11.5 L5.25,11.5 L7.75,9 L5.25,6.5 Z M9,10.25 L6.5,12.75 L6.5,17.3333333 L11.5,17.3333333 L11.5,12.75 L9,10.25 Z",
    id: "Shape"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGames);
export default __webpack_public_path__ + "static/media/games.0eb0452b107b8ace8f0efd54e8d3f1b6.svg";
export { ForwardRef as ReactComponent };